import script from "./SeoText.vue?vue&type=script&lang=ts&setup=true"
export * from "./SeoText.vue?vue&type=script&lang=ts&setup=true"

import "./SeoText.vue?vue&type=style&index=0&id=ea8259a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea8259a2"]])

export default __exports__